import React, { FC } from 'react'

const CircleInfoIcon: FC = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 13.3333C0 5.96953 5.96954 0 13.3333 0C20.6971 0 26.6667 5.96954 26.6667 13.3333C26.6667 20.6971 20.6971 26.6667 13.3333 26.6667C5.96953 26.6667 0 20.6971 0 13.3333ZM14.6667 8.83187C14.6667 8.09549 14.0697 7.49853 13.3333 7.49853C12.597 7.49853 12 8.09549 12 8.83187V8.83337C12 9.56975 12.597 10.1667 13.3333 10.1667C14.0697 10.1667 14.6667 9.56975 14.6667 8.83337V8.83187ZM14.6667 13.3334C14.6667 12.597 14.0697 12 13.3333 12C12.597 12 12 12.597 12 13.3334V18.6667C12 19.4031 12.597 20 13.3333 20C14.0697 20 14.6667 19.4031 14.6667 18.6667V13.3334Z"
      fill="currentColor"
    />
  </svg>
)

export default CircleInfoIcon
